import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
    flex: '1 1 auto',
    minWidth: 0,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginLeft: 'auto',
  },
}));

/**
 * Unified toolbar above list tables: filters on the left, primary actions on the right.
 * Plain layout (no Paper) so a single control does not look boxed-in.
 */
export default function TablePageToolbar({ filters, secondary, actions }) {
  const classes = useStyles();
  const hasFilters = filters != null || secondary != null;
  const hasActions = actions != null;
  if (!hasFilters && !hasActions) {
    return null;
  }

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        {hasFilters ? (
          <div className={classes.filters}>
            {filters}
            {secondary}
          </div>
        ) : null}
        {hasActions ? <div className={classes.actions}>{actions}</div> : null}
      </div>
    </div>
  );
}

TablePageToolbar.propTypes = {
  filters: PropTypes.node,
  secondary: PropTypes.node,
  actions: PropTypes.node,
};
